// Ported from vendor-ref/mara/app/ui/src/store/device.js:6-37 — breakpoints and the persisted dark flag
// (localStorage 'nanome-device' there, 'nanome-lite-device' here). Mobile layout is !breakpoints.md.
import { computed, watchEffect } from 'vue';
import { breakpointsTailwind, useBreakpoints, useLocalStorage } from '@vueuse/core';

const breakpoints = useBreakpoints(breakpointsTailwind);
const isDark = useLocalStorage<boolean>('nanome-lite-device.isDark', true);
const panelCollapsed = useLocalStorage<boolean>('nanome-lite-device.panelCollapsed', false);

let applied = false;

export function useDevice() {
  if (!applied) {
    applied = true;
    watchEffect(() => document.documentElement.classList.toggle('dark', isDark.value));
  }
  return {
    breakpoints,
    isDark,
    panelCollapsed,
    isMobile: computed(() => !breakpoints.md.value),
    isMac: typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform),
    toggleDark: () => { isDark.value = !isDark.value; },
  };
}
